<template>
  <div class="wrap-list">
    <div class="title-list" :class="{'is-basic-title': isBasic}">
      <div class="name-block">
        <button v-on:click="isShowList = !isShowList" class="d-flex align-items-center">
          <svg class="svg-dart" :class="{'rotate-180': !isShowList}" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 4.39999L6.00001 8.39999L10 4.39999H2Z" fill="#2c2c2c"/>
          </svg>
          <p class="text-name ml8 fz20 fw500 text-dark mr8">{{name}}</p>
        </button>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="isBasic">
          <circle cx="9" cy="9" r="9" fill="#6B8DAA"/>
          <path d="M9.86719 14H5.90918V4.13574H9.84668C10.7217 4.13574 11.4235 4.36133 11.9521 4.8125C12.4808 5.25911 12.7451 5.85384 12.7451 6.59668C12.7451 7.12077 12.5742 7.59017 12.2324 8.00488C11.8952 8.41504 11.4805 8.66113 10.9883 8.74316V8.79785C11.6628 8.87533 12.2051 9.13509 12.6152 9.57715C13.0254 10.0146 13.2305 10.5592 13.2305 11.2109C13.2305 12.0814 12.932 12.765 12.335 13.2617C11.738 13.7539 10.9154 14 9.86719 14ZM7.44043 5.38672V8.33301H9.15625C9.81706 8.33301 10.3252 8.20085 10.6807 7.93652C11.0361 7.6722 11.2139 7.29622 11.2139 6.80859C11.2139 6.35286 11.0635 6.00195 10.7627 5.75586C10.4619 5.50977 10.0335 5.38672 9.47754 5.38672H7.44043ZM7.44043 12.749H9.55273C10.2409 12.749 10.765 12.61 11.125 12.332C11.485 12.054 11.665 11.6484 11.665 11.1152C11.665 10.0397 10.9313 9.50195 9.46387 9.50195H7.44043V12.749Z" fill="white"/>
        </svg>
        <checklist-dropdown-select-user @on-change="(e)=>{activeUser = e}" :active-user="activeUser" v-else></checklist-dropdown-select-user>
      </div>
      <div class="dop-block ml-auto" v-if="!isArchive">
        <button class="archive" v-if="isBasic" v-on:click="$emit('archive')">
          <svg v-if="!isArchive" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.12 9.96H19.72L18.76 19.24H5.96L5 9.96H6.76M18.12 9.96L18.6 7.4H16.52M18.12 9.96H6.76M6.76 9.96L6.12 7.4H8.2M8.2 7.4L7.72 5H17L16.52 7.4M8.2 7.4H16.52M9.96 13.32H14.76" stroke="#2C2C2C" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="blue-button fz13 fw500 ml16" v-on:click="createNewList" v-if="(isBasic && getPermissionsByType('create_or_edit_base_checklist')) || (!isBasic && activeUser && activeUser.id === getLoginData.data.user.id)">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3333 7.33332H8.66668V2.66662C8.66668 2.2987 8.36798 2 7.99994 2C7.63202 2 7.33332 2.2987 7.33332 2.66662V7.33332H2.66662C2.2987 7.33332 2 7.63202 2 7.99994C2 8.36798 2.2987 8.66668 2.66662 8.66668H7.33332V13.3333C7.33332 13.7013 7.63202 14 7.99994 14C8.36798 14 8.66668 13.7013 8.66668 13.3333V8.66668H13.3333C13.7013 8.66668 14 8.36798 14 7.99994C14 7.63202 13.7013 7.33332 13.3333 7.33332Z" fill="white"/>
          </svg>
          Create new
        </button>
      </div>
    </div>
    <app-loader v-if="isShowLoader" :is-local="true" class="loader"></app-loader>
    <div class="list" v-show="isShowList && list.length">
      <div class="list-item list-item-hover-active cursor-pointer" :class="{'active-item': activeId === item.id}" v-for="(item, i) in list" :key="i" v-on:click="openDetail(item)">
        <p class="name-text fz14 text-dark" :key="keyRender" :contenteditable="(item.is_basic && getPermissionsByType('create_or_edit_base_checklist') || !item.is_basic && item.creator.id === getLoginData.data.user.id) && !isArchive" @focusin="checkNameCheckListForEdit" @blur="(e)=>{setNewInputValueName(e, item)}">{{item.name}}</p>
        <p class="d-flex align-items-center fz13 text-gray ml12">
          <svg width="12" class="mr4" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2.66667C0 1.19391 1.19391 0 2.66667 0H9.33333C10.8061 0 12 1.19391 12 2.66667V9.33333C12 10.8061 10.8061 12 9.33333 12H2.66667C1.19391 12 0 10.8061 0 9.33333V2.66667Z" fill="#9AA3B0"/>
            <path d="M9.66668 3.3463C9.45786 3.11426 9.11332 3.10782 8.8971 3.33193C8.89257 3.33662 8.88811 3.34141 8.88371 3.3463L5.17598 7.27826L3.25571 5.85796C3.03949 5.63386 2.69495 5.64029 2.48613 5.87234C2.28241 6.09871 2.28241 6.45756 2.48613 6.68393L4.79119 8.51719C5.00374 8.74523 5.34825 8.74523 5.56077 8.51719L9.65328 4.17227C9.8695 3.94813 9.8755 3.57835 9.66668 3.3463Z" fill="white"/>
          </svg>
          {{getItemsLength(item.items)}}
        </p>
        <p class="d-flex align-items-center fz13 text-gray ml12">
          <svg width="12" class="mr4" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.00809 2.8634C7.00809 3.12504 6.79847 3.33714 6.53989 3.33714L5.24016 3.33714C4.98158 3.33714 4.77197 3.12504 4.77197 2.8634L4.72919 0.473741C4.72919 0.212101 4.93881 4.03386e-07 5.19739 4.03386e-07L6.49712 0C6.7557 0 6.96532 0.212101 6.96532 0.473741L7.00809 2.8634Z" fill="#9AA3B0"/>
            <path d="M7.99109 9.90658C6.68551 10.9507 5.01606 10.9507 3.71046 9.90658C3.05765 10.4287 2.3139 10.7157 1.57015 10.7157H1.13465C0.784149 10.7157 0.500007 11.0032 0.5 11.3578C0.499993 11.7125 0.78414 12 1.13465 12H1.57015C2.30588 12 3.03626 11.7893 3.71046 11.3924C5.05885 12.1832 6.64269 12.1832 7.99109 11.3924C8.66529 11.7863 9.39567 12 10.1314 12H10.5669C10.9174 12 11.2016 11.7125 11.2016 11.3578C11.2016 11.0032 10.9174 10.7157 10.5669 10.7157H10.1314C9.38765 10.7157 8.6439 10.4287 7.99109 9.90658Z" fill="#9AA3B0"/>
            <path d="M11.1273 5.37981C11.4619 5.5185 11.627 5.90118 11.5 6.24376L10.259 9.30907H10.1403C9.39655 9.30907 8.6528 9.02208 8 8.5C6.69442 9.54415 5.02497 9.54415 3.71937 8.5C3.11859 8.98047 2.44078 9.26184 1.75683 9.30363L0.585554 6.24376C0.458553 5.90118 0.623638 5.5185 0.958256 5.37981L2.54934 4.96678L2.54933 2.35307C2.54933 2.09143 2.75895 1.87933 3.01753 1.87933L5.24016 1.87934H6.8454L8.76963 1.87887C9.0282 1.87887 9.23782 2.09097 9.23782 2.35261V4.96632L11.1273 5.37981Z" fill="#9AA3B0"/>
          </svg>
          {{item.vessels.length}}
        </p>
        <button class="delete" v-if="!isArchive && activeId === item.id && ((isBasic && getPermissionsByType('create_or_edit_base_checklist')) || !isBasic)" v-on:click="idForArchive = item.id; isShowModalArchive=true" v-tooltip.top="'Delete checklist'">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6364 4.36585C10.5073 4.36585 10.4091 4.46907 10.4091 4.58852V5.26399H13.5909V4.58852C13.5909 4.46907 13.4927 4.36585 13.3636 4.36585L10.6364 4.36585ZM14.9545 5.26399V4.58852C14.9545 3.70768 14.2387 3 13.3636 3L10.6364 3C9.76125 3 9.04545 3.70768 9.04545 4.58852V5.26399H5.18182C4.80526 5.26399 4.5 5.56975 4.5 5.94692C4.5 6.32409 4.80526 6.62984 5.18182 6.62984H6.31818V16.5059C6.31818 17.8869 7.441 19 8.81818 19H15.1818C16.559 19 17.6818 17.8869 17.6818 16.5059V6.62984H18.8182C19.1947 6.62984 19.5 6.32409 19.5 5.94692C19.5 5.56975 19.1947 5.26399 18.8182 5.26399H14.9545ZM7.68182 6.62984V16.5059C7.68182 17.1255 8.18706 17.6341 8.81818 17.6341H15.1818C15.8129 17.6341 16.3182 17.1255 16.3182 16.5059V6.62984H7.68182ZM10.6364 8.88637C11.0129 8.88637 11.3182 9.19213 11.3182 9.5693V14.5501C11.3182 14.9272 11.0129 15.233 10.6364 15.233C10.2598 15.233 9.95455 14.9272 9.95455 14.5501V9.5693C9.95455 9.19213 10.2598 8.88637 10.6364 8.88637ZM13.3636 8.88637C13.7402 8.88637 14.0455 9.19213 14.0455 9.5693V14.5501C14.0455 14.9272 13.7402 15.233 13.3636 15.233C12.9871 15.233 12.6818 14.9272 12.6818 14.5501V9.5693C12.6818 9.19213 12.9871 8.88637 13.3636 8.88637Z" fill="#2C2C2C"/>
          </svg>
        </button>
        <button class="unarchive" v-if="isArchive && ((isBasic && getPermissionsByType('create_or_edit_base_checklist')) || (!isBasic && activeUser && activeUser.id === getLoginData.data.user.id))" :class="{'d-flex': activeId === item.id}" v-on:click="idForArchive = item.id; isShowModalArchive=true" v-tooltip.top="'Unarchive checklist'">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.01736 9.78525L6.71267 7.00237L9.01736 4.21949C9.28441 3.91345 9.25326 3.44872 8.94722 3.18143C8.64119 2.91438 8.1767 2.94578 7.90916 3.25157L5.18172 6.51852C4.93943 6.79562 4.93943 7.20934 5.18172 7.48644L7.9092 10.7534C8.05485 10.9197 8.25865 11.005 8.46365 11.005C8.63532 11.005 8.80769 10.9452 8.94722 10.8233C9.25329 10.556 9.28465 10.0913 9.01736 9.78525Z" fill="#2C2C2C"/>
            <path d="M13.6538 6.26562H5.73568C5.32934 6.26562 5 6.59493 5 7.0013C5 7.40764 5.32934 7.73698 5.73568 7.73698H13.6538C15.7904 7.73698 17.5286 9.60036 17.5286 11.9785C17.5286 14.3567 15.7904 16.4862 13.6538 16.4862H6.71661C6.31027 16.4862 5.98093 16.8155 5.98093 17.2219C5.98093 17.6282 6.31027 17.9576 6.71661 17.9576H13.6538C16.6014 17.9576 19 15.212 19 11.9785C19 8.74505 16.6017 6.26562 13.6538 6.26562Z" fill="#2C2C2C"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="no-list d-flex align-items-center justify-center flex-column" v-if="isShowList && !list.length">
      <svg width="75" height="74" viewBox="0 0 75 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M32.2214 0.595033C32.7478 0.208281 33.3843 0 34.0374 0H40.8934C41.5738 0 42.2353 0.225973 42.7729 0.642954L49.4402 5.81349C49.7341 6.04148 49.9803 6.31808 50.1704 6.62739C50.4614 7.10081 50.6212 7.65106 50.6212 8.22088V9.71396C50.6212 11.4033 49.2462 12.7643 47.5606 12.7643H26.9545C25.2689 12.7643 23.8939 11.4033 23.8939 9.71396V9.41419H16.1364C14.1233 9.41419 12.5 11.0366 12.5 13.0275V68.3867C12.5 70.3776 14.1233 72 16.1364 72H57.8636C59.8767 72 61.5 70.3776 61.5 68.3867V13.0275C61.5 11.0366 59.8767 9.41419 57.8636 9.41419C57.3114 9.41419 56.8636 8.96647 56.8636 8.41419C56.8636 7.8619 57.3114 7.41419 57.8636 7.41419C60.9718 7.41419 63.5 9.92263 63.5 13.0275V68.3867C63.5 71.4915 60.9718 74 57.8636 74H16.1364C13.0282 74 10.5 71.4915 10.5 68.3867V13.0275C10.5 9.92264 13.0282 7.41419 16.1364 7.41419H24.0122C24.094 7.12989 24.2166 6.85938 24.3758 6.61116C24.5755 6.29985 24.8327 6.02351 25.1385 5.79884L32.2214 0.595033ZM34.0374 2C33.8095 2 33.588 2.07274 33.4055 2.20679L26.3226 7.4106C26.2166 7.4885 26.128 7.58384 26.0593 7.6909C25.9524 7.85756 25.8939 8.05238 25.8939 8.25415V9.71396C25.8939 10.2893 26.3641 10.7643 26.9545 10.7643H47.5606C48.1511 10.7643 48.6212 10.2893 48.6212 9.71396V8.22088C48.6212 8.02612 48.5667 7.83763 48.4665 7.67467C48.4012 7.56833 48.3164 7.47294 48.2145 7.39393L41.5473 2.22339C41.361 2.07892 41.1309 2 40.8934 2H34.0374ZM28.4361 22.5738C28.8257 22.9653 28.8241 23.5985 28.4326 23.988L24.1163 28.2828C23.1227 29.2715 21.5137 29.2715 20.52 28.2828L19.2947 27.0636C18.9032 26.674 18.9016 26.0408 19.2911 25.6494C19.6807 25.2579 20.3138 25.2563 20.7053 25.6458L21.9307 26.8651C22.1441 27.0775 22.4922 27.0775 22.7056 26.8651L27.0219 22.5703C27.4134 22.1808 28.0466 22.1823 28.4361 22.5738ZM33.9394 26.8673C33.9394 26.315 34.3871 25.8673 34.9394 25.8673H44.7273C45.2796 25.8673 45.7273 26.315 45.7273 26.8673C45.7273 27.4196 45.2796 27.8673 44.7273 27.8673H34.9394C34.3871 27.8673 33.9394 27.4196 33.9394 26.8673ZM49.9091 26.8673C49.9091 26.315 50.3568 25.8673 50.9091 25.8673H51.9394C52.4917 25.8673 52.9394 26.315 52.9394 26.8673C52.9394 27.4196 52.4917 27.8673 51.9394 27.8673H50.9091C50.3568 27.8673 49.9091 27.4196 49.9091 26.8673ZM22.8333 38.6316C21.1048 38.6316 19.7121 40.0245 19.7121 41.7323C19.7121 43.44 21.1048 44.8329 22.8333 44.8329C24.5618 44.8329 25.9545 43.44 25.9545 41.7323C25.9545 40.0245 24.5618 38.6316 22.8333 38.6316ZM17.7121 41.7323C17.7121 38.9105 20.0097 36.6316 22.8333 36.6316C25.657 36.6316 27.9545 38.9105 27.9545 41.7323C27.9545 44.554 25.657 46.8329 22.8333 46.8329C20.0097 46.8329 17.7121 44.554 17.7121 41.7323ZM33.9394 41.7323C33.9394 41.18 34.3871 40.7323 34.9394 40.7323H51.9394C52.4917 40.7323 52.9394 41.18 52.9394 41.7323C52.9394 42.2845 52.4917 42.7323 51.9394 42.7323H34.9394C34.3871 42.7323 33.9394 42.2845 33.9394 41.7323ZM22.8333 54.0092C21.1048 54.0092 19.7121 55.4021 19.7121 57.1098C19.7121 58.8176 21.1048 60.2105 22.8333 60.2105C24.5618 60.2105 25.9545 58.8176 25.9545 57.1098C25.9545 55.4021 24.5618 54.0092 22.8333 54.0092ZM17.7121 57.1098C17.7121 54.2881 20.0097 52.0092 22.8333 52.0092C25.657 52.0092 27.9545 54.2881 27.9545 57.1098C27.9545 59.9316 25.657 62.2105 22.8333 62.2105C20.0097 62.2105 17.7121 59.9316 17.7121 57.1098ZM33.9394 57.1098C33.9394 56.5576 34.3871 56.1098 34.9394 56.1098H51.9394C52.4917 56.1098 52.9394 56.5576 52.9394 57.1098C52.9394 57.6621 52.4917 58.1098 51.9394 58.1098H34.9394C34.3871 58.1098 33.9394 57.6621 33.9394 57.1098Z" fill="#BDCBD6"/>
      </svg>
      <p v-if="isBasic && getPermissionsByType('create_or_edit_base_checklist')" class="text-align-center mt16 text-dark fz14">To create basic checklist <br>click on Create new</p>
      <p v-else-if="isBasic" class="text-align-center mt16 text-dark fz14">Checklist is empty</p>
      <p v-if="!isBasic && activeUser && activeUser.id === getLoginData.data.user.id" class="text-align-center mt16 text-dark fz14">To create your own checklist <br>click on Create new</p>
      <p v-else-if="!isBasic" class="text-align-center mt16 text-dark fz14">Checklist is empty</p>
    </div>
    <modal-slots :isBorder="false" class="archive-modal" :showMod="isShowModalArchive" @close="isShowModalArchive = false">
      <template v-slot:title>
        <h2 class="fz16 fw500 text-dark">{{isArchive ? 'Unarchive' : 'Archive'}} the Checklist</h2>
      </template>

      <p class="fz14 text-dark p24">Are you sure you want to {{isArchive ? 'unarchive' : 'archive'}} this Checklist?</p>

      <template v-slot:bottomFirstButton>
        <button class="blue-button-text fz14" @click="isShowModalArchive = false">Cancel</button>
      </template>
      <template v-slot:bottomSecondButton>
        <button class="m-l-8 p-x-16 blue-button fz14 fw500" @click="archiveCheckList(idForArchive)">{{isArchive ? 'Unarchive' : 'Archive'}}</button>
      </template>
    </modal-slots>
  </div>
</template>

<script>
import ChecklistDropdownSelectUser from "@/components/checklist/checklist-dropdown-select-user";
import AppLoader from "@/components/loader";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import ModalSlots from "@/components/modal/modal-slots";
export default {
  name: "checklist-edit-toggle-hide-list",
  components: {ModalSlots, AppLoader, ChecklistDropdownSelectUser},
  computed: {
    ...mapGetters(['getLoginData', 'getPermissionsByType']),
    ...mapState({
      sortToName: state => state.checklistPage.sortToName
    })
  },
  props: {
    activeId: Number,
    name: {
      type: String,
      default: '',
    },
    isBasic: Boolean,
    isArchive: Boolean,
  },
  data() {
    return {
      keyRender: -9786234,
      isShowModalArchive: false,
      isShowList: true,
      isShowLoader: false,
      activeUser: null,
      list: [],
      createForm: {
        name: 'Name',
        is_basic: this.isBasic,
        is_archived: false,
        vessels: [],
        items: [],
      },
      idForArchive: null,
    }
  },
  watch: {
    isArchive: function () {
      this.loadList()
    },
    activeUser: function () {
      if(!this.isBasic) {
        this.loadList()
      }
    },
    sortToName: function () {
      this.list.sort((a, b)=> a.name > b.name ? 1 : -1)
      setTimeout(()=> {
        this.keyRender++
      }, 30)
    },
  },
  methods: {
    ...mapActions(['axiosCreateNewCheckList', 'axiosGetCheckLists', 'axiosPatchChecklist']),
    ...mapMutations(['showLoad', 'hideLoad']),
    checkNameCheckListForEdit(e) {
      if(e && e.target.innerText === 'Name') {
        setTimeout(()=> {
          e.target.innerText = ''
        }, 50)
      }
    },
    setNewInputValueName(e, item) {
      if(e.target.innerText.length !== 0 && e.target.innerText !== item.name) {
        e.target.innerText = e.target.innerText.slice(0, 255)
        item.name = e.target.innerText
        this.changeCheckList(item)
        setTimeout(()=> {
          this.list.sort((a, b)=> a.name > b.name ? 1 : -1)
          setTimeout(()=> {
            this.keyRender++
          }, 30)
        }, 0)
      } else{
        e.target.innerText = item.name
      }
    },
    getItemsLength(items) {
      if(this.isBasic && !this.getPermissionsByType('create_or_edit_base_checklist')) {
          return items.filter(a=> a && ( a.is_basic || (!a.is_basic && a.creator && a.creator.id === this.getLoginData.data.user.id))).length
      }
        return items.length
    },
    async archiveCheckList(id) {
      this.isShowModalArchive = false
      let item = JSON.parse(JSON.stringify(this.list.find(a=> a.id === id)))
      let form = {
        name: item.name,
        is_basic: item.is_basic,
        is_archived: !item.is_archived,
        vessels: item.vessels.map(a=> {return a.id}),
        items: item.items
      }
      form.items.forEach((item, index)=> {
        item.index = index;
      })
      if(this.activeId === id) {
        this.$emit('closeDetail')
      }
      this.list = this.list.filter(a=> a.id !== id)
      await this.axiosPatchChecklist({id:item.id,form: form})
    },
    changeCheckList(itemCH) {
      let item = JSON.parse(JSON.stringify(itemCH))
      let form = {
        name: item.name,
        is_basic: item.is_basic,
        is_archived: item.is_archived,
        vessels: item.vessels.map(a=> {return a.id}),
        items: item.items
      }
      form.items.forEach((item, index)=> {
        item.index = index;
      })
      // console.log('change, form', form)
      this.axiosPatchChecklist({id:item.id,form: form})
    },
    // axiosDelete(id) {
    //   this.axiosDeleteCheckList(id);
    //   this.list = this.list.filter(a=> a.id !== id)
    // },
    async createNewList() {
      // this.showLoad()
      this.isShowLoader = true;
      let item = await this.axiosCreateNewCheckList(this.createForm)
      this.list.push(JSON.parse(JSON.stringify(item.data)))
      this.list.sort((a, b)=> a.name > b.name ? 1 : -1)
      setTimeout(()=> {
        this.openDetail(this.list.find(a => a.id === item.data.id))
        // this.hideLoad()
        this.isShowLoader = false;
      }, 100)

    },
    openDetail(detail) {
      this.$emit('open-detail', detail)
    },
    loadList() {
      this.isShowLoader = true
      let params = {
        is_basic: this.isBasic,
        is_archived: this.isArchive
      }
      if(!this.isBasic) {
        params['creator'] = this.activeUser.id
      }
      this.axiosGetCheckLists(params).then(res=> {
        this.list = res.filter(a=> a.is_basic === this.isBasic)
        this.list.sort((a, b)=> a.name > b.name ? 1 : -1)
        this.list.forEach(list=> {
          list.items.sort((a, b) => a.index > b.index ? 1 : -1)
        })
        this.list.forEach(list=> {
          list.items.forEach((item, index)=> {
            item.index = index
          })
        })
        this.isShowLoader = false
      })
    }
  },
  mounted() {
    if(!this.activeUser) {
      this.activeUser = {id: this.getLoginData.data.user.id ,first_name: this.getLoginData.data.user.first_name, last_name: this.getLoginData.data.user.last_name ,avatar: this.getLoginData.data.user.avatar}
    }
    this.loadList()
  }
}
</script>

<style scoped lang="scss">
  .wrap-list {
    width: 100%;
    position: relative;
  }
  .title-list {
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;
    padding: 4px 24px;
    box-sizing: border-box;
    border-top: 1px solid var(--color-border);
    border-bottom: 1px solid var(--color-border);
  }
  .is-basic-title {
    border-top: none !important;
  }
  .name-block {
    position: relative;
    z-index: 10;
    display: flex;
    align-items: center;
  }
  .dop-block {
    display: flex;
    align-items: center;
  }
  .archive {
    width: max-content;
    height: max-content;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .list-item {
    width: 100%;
    box-sizing: border-box;
    padding: 5px 57px 5px 24px;
    display: flex;
    min-height: 36px;
    box-sizing: border-box;
    align-items: center;
    position: relative;
    .name-text {
      max-width: 368px;
      //overflow: hidden;
      display: -webkit-box;
      //-webkit-line-clamp: 2;
      //-webkit-box-orient: vertical;
      height: 100%;
      box-sizing: border-box;
      word-break: break-all;
    }
    .delete {
      position: absolute;
      right: 16px;
      display: none;
      align-items: center;
      justify-content: center;
      width: max-content;
      height: max-content;
    }
    .unarchive {
      position: absolute;
      right: 16px;
      align-items: center;
      justify-content: center;
      width: max-content;
      height: max-content;
      display: none;
    }
  }
  .list-item-hover-active {
    &:hover {
      background-color: var(--color-gray-lightest);
      .unarchive {
        display: flex;
      }
    }
    .delete {
      display: flex;
    }
  }
  .no-list {
    height: 204px;
    display: flex;
  }
  .loader {
    position: absolute;
    top: 40px;
    height: calc(100% - 40px);
    width: 100%;
        background-color: rgba(255, 255, 255, 0.7) !important;
  }
  .dart-mode {
    .loader {
          background-color: rgba(35, 37, 48, 0.7) !important;
    }
  }
  .active-item {
    background-color: #E5EEFF !important;
  }
  .d-flex {
    display: flex !important;
  }
  .archive-modal {
    /deep/ {
      .top-panel {
        padding: 12px 16px 0 16px !important;
      }
      .main-block {
        p {
          padding: 20px 16px 20px 16px !important;
        }
      }
      .bottom-panel {
        padding: 0 16px 12px 16px !important;
      }
    }
  }
  .dart-mode {
    .archive {
      svg {
        path {
          stroke: #9AA3B0;
        }
      }
    }
    .active-item {
      background-color: #333E58 !important;
    }
    .delete, .unarchive {
      svg {
        path {
          fill: #9AA3B0;
        }
      }
    }
    .title-list {
      border-top: 1px solid #4D546D;
      border-bottom: 1px solid #4D546D;
    }
  }
</style>